import React, { Component } from 'react';
import '../css/dataTables.css';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Código'},
    {title: 'Nombre'}
];

class CentroCosteModal extends Component {

    componentDidMount(): void {
        this.closeAction();
    }

    closeRegion = async () => {
        $('#CentroCoste').modal('hide');
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $('#CentroCoste').on('hidden.bs.modal', () => {
            //console.log("Close CentroCoste");
            cleanData();
        });
    };

    render() {
        const {data, selectCentroCoste} = this.props;
        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="CentroCoste"></div>;
        }

        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="CentroCoste" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Centro de Coste</h4>
                                <button type="button" className="close" onClick={this.closeRegion} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"CentroCosteModal"} action={selectCentroCoste}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeRegion}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
        );
    }
}

export default CentroCosteModal;